/* O7 — verbatim MagicPath port: interaction.
 * Ported from the design's own script (tier select, gift unlock, dual countdown, local date)
 * and wired to the THEME (writes the selected tier's quantity + selling_plan to the product
 * form so the ORIGINAL theme CTA adds the right thing; relocates the deal bar to page top;
 * auto-adds unlocked $0 gift lines like O6). Operates document-wide because the module is
 * split across two blocks (A above the CTA, B below it).
 */
(() => {
  const QS = (s, r = document) => r.querySelector(s);
  const QSA = (s, r = document) => [...r.querySelectorAll(s)];

  function init() {
    const blockA = QS('[data-mpo7]');
    if (!blockA || blockA.dataset.mpInit) return;
    blockA.dataset.mpInit = '1';

    const options = QSA('[data-option]');
    const gifts = QSA('[data-gift-id]');
    const subscribeBox = QS('[data-subscribe-box]');
    const refillLine = QS('[data-refill-line]');
    const benefitLine = QS('[data-benefit-line]');
    const oneTimeBtn = QS('[data-one-time]');
    if (!options.length) return;

    /* ---- theme product form hookup ---- */
    const formId = blockA.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const ensure = (name) => {
      if (!form) return null;
      let el = form.querySelector(`[name="${name}"]`);
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; form.appendChild(el); }
      return el;
    };
    const qtyInput = ensure('quantity');
    const planInput = ensure('selling_plan');
    const strayPlans = () => QSA('.pp_sub_plan_value');

    /* CTA visual: graft the design's .atc shine sweep + arrow pill onto the theme's submit button */
    const ctaBtn = form ? form.querySelector('.product-form__submit, button[name="add"]') : null;
    if (ctaBtn && !ctaBtn.dataset.mpCta) {
      ctaBtn.dataset.mpCta = '1';
      ctaBtn.classList.add('mp-cta');
      const shine = document.createElement('span');
      shine.className = 'mp-cta-shine'; shine.setAttribute('aria-hidden', 'true');
      const arrow = document.createElement('span');
      arrow.className = 'mp-cta-arrow'; arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = '<svg viewBox="0 0 18 18" focusable="false"><path d="M4 9h9.2M9.6 5.4 13.2 9l-3.6 3.6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      ctaBtn.appendChild(shine);
      ctaBtn.appendChild(arrow);
    }

    /* gift id -> Shopify $0 product variant for auto-add (shared with O6). 1 Gut Reset Protocol,
       2 60-Day Guarantee, 4 Mystery Gift, 5 Apple Watch Entry. Gift 3 (Free Shipping) is
       display-only (no product). Gift 5 is a cart line AND still sets the _apple_watch_entry attr
       (Shopify Flow order tag for the giveaway draw). */
    const GIFT_VARIANT = { 1: 51030169419916, 2: 51021853720716, 4: 51030168305804, 5: 51021851885708 };
    const giftVids = Object.values(GIFT_VARIANT);
    let unlocked = [];
    // the main bottle variant (single SKU). Used by Rule 5 (drop gifts if the bottle leaves the cart)
    // and Rule 6 (render the bottle first in the UpCart drawer).
    const bottleVid = Number((form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value) || (options[0] && options[0].dataset.variantId) || 0);

    function updateOffer(selected, fireForm) {
      const ids = (selected.dataset.giftUnlocks || '').split(',').map((s) => s.trim()).filter(Boolean);
      unlocked = ids.map(Number);
      options.forEach((o) => {
        const on = o === selected;
        o.classList.toggle('is-selected', on);
        const r = o.querySelector('input'); if (r) r.checked = on;
      });
      gifts.forEach((g) => g.classList.toggle('is-unlocked', ids.includes(g.dataset.giftId || '')));
      if (subscribeBox) {
        const disc = selected.dataset.bottles === '1'
          ? `${selected.dataset.discount || '0'}% OFF Every Order`
          : `${selected.dataset.discount || '0'}% OFF First Order*`;
        subscribeBox.textContent = `Subscribe & Save - ${selected.dataset.deliveryCopy || 'Every Month'} - ${disc}`;
      }
      if (refillLine) refillLine.textContent = selected.dataset.refillCopy || refillLine.textContent;
      if (benefitLine) benefitLine.textContent = selected.dataset.benefitCopy || benefitLine.textContent;
      // write to the theme form so the ORIGINAL CTA adds the selected tier
      const plan = selected.dataset.sellingPlanId && !/^\d{3}-plan$/.test(selected.dataset.sellingPlanId) ? selected.dataset.sellingPlanId : '';
      if (qtyInput) qtyInput.value = selected.dataset.bottles || '1';
      if (planInput) planInput.value = plan;
      strayPlans().forEach((el) => (el.value = plan));
    }

    options.forEach((o) => o.addEventListener('click', () => updateOffer(o, true)));

    /* one-time: qty 1, NO plan, NO gifts. The button is type=submit but sits OUTSIDE the
       product form, so its own submit is inert — drive the real CTA instead. Setting
       unlocked=[] first makes the shared reconcileGifts drop any gift lines and clear the
       Apple-Watch attr; the native CTA click then adds the qty-1/no-plan bottle + opens UpCart. */
    if (oneTimeBtn) {
      oneTimeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        unlocked = [];
        if (qtyInput) qtyInput.value = '1';
        if (planInput) planInput.value = '';
        strayPlans().forEach((el) => (el.value = ''));
        if (primaryBtn) primaryBtn.click();
      });
    }

    /* unlocked gifts ride along on the theme CTA (auto-add $0, dedupe, drop stale) */
    const primaryBtn = form ? form.querySelector('button[name="add"]') : null;
    let busy = false;
    async function reconcileGifts() {
      if (busy) return; busy = true;
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const inCart = {}; (cart.items || []).forEach((it) => (inCart[it.variant_id] = it));
        const want = new Set(unlocked.map((id) => GIFT_VARIANT[id]).filter(Boolean));
        const toAdd = [...want].filter((id) => !inCart[id]);
        const toRemove = giftVids.filter((id) => !want.has(id) && inCart[id]);
        if (toAdd.length) await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: toAdd.map((id) => ({ id, quantity: 1 })) }) });
        for (const id of toRemove) await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: inCart[id].key, quantity: 0 }) });
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _apple_watch_entry: unlocked.includes(5) ? 'true' : '' } }) });
      } catch (e) {} finally { setTimeout(() => (busy = false), 1200); }
    }
    // Rule 6 (main product first): UpCart's drawer renders cart lines newest-added-first, so the bottle
    // (added by the native CTA before our $0 gifts) shows up below them. Rather than mutate the real cart
    // (which caused a visible add-then-reorder flicker), use UpCart's display hook to render the bottle on
    // top — no cart change, no reflow. UpCart calls window.upcartModifyCart(cart) before each render.
    if (bottleVid && !window.__mpBottleFirst) {
      window.__mpBottleFirst = bottleVid;
      window.upcartModifyCart = function (cart) {
        try {
          if (!cart || !Array.isArray(cart.items)) return cart;
          const b = cart.items.filter((i) => i.variant_id === window.__mpBottleFirst);
          if (!b.length) return cart;
          return Object.assign({}, cart, { items: b.concat(cart.items.filter((i) => i.variant_id !== window.__mpBottleFirst)) });
        } catch (e) { return cart; }
      };
    }
    if (primaryBtn) primaryBtn.addEventListener('click', () => reconcileGifts());

    /* Rule 5 (gift depends on main product): when the customer removes the bottle in the UpCart drawer,
       drop every gift line and clear the Apple-Watch attr so no orphan free gifts remain. Uses UpCart's
       official upcartSubscribeItemRemoved event (fires on any drawer item removal); we re-read the cart
       and only act once the bottle is actually gone. Our own gift removals use plain fetch, which does
       NOT fire UpCart events → no feedback loop. upcartRefreshCart() repaints the drawer afterwards. */
    let enforcing = false;
    async function enforceGiftDependency() {
      if (busy || enforcing || !bottleVid) return;
      enforcing = true;
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const items = cart.items || [];
        if (items.some((it) => it.variant_id === bottleVid && it.quantity > 0)) return; // bottle still present
        const giftLines = items.filter((it) => giftVids.includes(it.variant_id));
        const hasAttr = cart.attributes && cart.attributes._apple_watch_entry;
        if (!giftLines.length && !hasAttr) return; // nothing to clean (also stops any refresh feedback loop)
        // Batch ALL gift removals + the attr clear into ONE /cart/update.js. The old per-gift
        // /cart/change.js loop ran sequentially; on this store each cart write is a heavy Skio/UpCart
        // recalc (~1s) so 4 chained writes + a separate attr update.js = ~5s before the gifts dropped.
        // One update.js (line-key -> 0 map + attributes) = one recalc, ~1s. (verified 2026-06-26)
        const updates = {};
        giftLines.forEach((g) => { updates[g.key] = 0; });
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates, attributes: { _apple_watch_entry: '' } }) });
        unlocked = [];
        if (window.upcartRefreshCart) window.upcartRefreshCart();
      } catch (e) {} finally { setTimeout(() => (enforcing = false), 600); }
    }
    if (bottleVid && !window.__mpGiftWatch) {
      window.__mpGiftWatch = true;
      // UpCart loads async — poll until its event API is ready, then subscribe (no fetch monkey-patch).
      (function subscribe(tries) {
        if (typeof window.upcartSubscribeItemRemoved === 'function') {
          window.upcartSubscribeItemRemoved(function () { setTimeout(enforceGiftDependency, 250); });
        } else if (tries < 40) {
          setTimeout(function () { subscribe(tries + 1); }, 250);
        }
      })(0);
    }

    /* local date with ordinal (design .date-mark / [data-local-date]) */
    const dateMark = QS('[data-local-date]') || QS('.date-mark');
    if (dateMark) {
      const d = new Date(), day = d.getDate();
      const suf = day % 10 === 1 && day % 100 !== 11 ? 'st' : day % 10 === 2 && day % 100 !== 12 ? 'nd' : day % 10 === 3 && day % 100 !== 13 ? 'rd' : 'th';
      dateMark.textContent = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(d) + ' ' + day + suf;
    }

    /* dual countdown — top-strip ([data-hours/minutes/seconds]) + code line ([data-discount-*]) */
    const endsAt = Date.now() + ((2 * 60 * 60) + (13 * 60) + 15) * 1000;
    const pad = (v) => String(v).padStart(2, '0');
    const set = (sel, v) => QSA(sel).forEach((el) => (el.textContent = v));
    function tick() {
      const left = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));
      const h = pad(Math.floor(left / 3600)), m = pad(Math.floor((left % 3600) / 60)), s = pad(left % 60);
      set('[data-hours]', h); set('[data-minutes]', m); set('[data-seconds]', s);
      set('[data-discount-hours]', h); set('[data-discount-minutes]', m); set('[data-discount-seconds]', s);
    }
    tick(); setInterval(tick, 1000);

    /* relocate the deal bar to the very top of the page (design: top strip above the header).
     * Wrap in a .mpo7 host so the scoped design CSS still applies once it leaves block A. */
    const bar = QS('.mpo7 .top-strip');
    if (bar && !bar.dataset.mpTop) {
      bar.dataset.mpTop = '1';
      const host = document.createElement('div');
      host.className = 'mpo7 mpo7-topbar-host';
      document.body.prepend(host);
      host.appendChild(bar);
      QSA('[id*="countdown_timer" i]').forEach((el) => { const sec = el.closest('.shopify-section') || el; sec.style.setProperty('display', 'none', 'important'); });
    }

    /* init to the 3-bottle (BEST CHOICE) tier */
    updateOffer(options.find((o) => o.dataset.bottles === '3') || options[0], false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
